import { render, staticRenderFns } from "./create-enquiry.vue?vue&type=template&id=7834c508&"
import script from "./create-enquiry.vue?vue&type=script&lang=ts&"
export * from "./create-enquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports